import getNestedValue from '@/services/functions/getNestedValue'
import setNestedValue from '@/services/functions/setNestedValue'
// import { cloneDeep } from 'lodash'

/**
 * Callback usado para filtrar las claves del objeto
 * @callback KeyPredicate
 * @param {string} key Clave actual
 * @param {number} index Índice de la clave en el array
 * @param {Array<string>} keys Array completo de claves
 * @returns {boolean} Indica si la clave pasa el filtro
 */

/** Devuelve un objeto con las claves especificadas
 * @param {Array} props Claves que se conservarán en la copia de obj
 * @param {Object} obj Objeto a copiar
 * @returns {Object} Copia de obj con las claves especificadas en props
 */
function preserve (props, obj) {
  const aux = {}
  props.forEach(prop => setNestedValue(prop, aux, getNestedValue(prop, obj)))
  return aux
  //   return discard(Object.keys(obj).filter(x => !props.map(p => String(p)).includes(x)), obj)
}

/** Devuelve un objeto con las claves que pasen el filtro
 * @param {Object} obj Objeto a copiar
 * @param {KeyPredicate} predicate Filtro que indicará si una clave se deberá conservar en la copia de obj. El método filter llama a la función predicate una vez por cada clave en obj.
 * @param {*} [thisArg] Un objeto al que puede hacer referencia la palabra clave this en la función predicado. Si se omite thisArg, se utiliza undefined como valor de this.
 * @returns {Object} Copia de obj con las claves que pasaron el filtro
 */
function preserveByPredicate (obj, predicate, thisArg = undefined) {
  const props = Object.keys(obj).filter(predicate, thisArg)
  return preserve(props, obj)
}

/** Devuelve un objeto sin las claves especificadas
 * @param {Array} props Claves que se eliminarán en la copia de obj
 * @param {Object} obj Objeto a copiar
 * @returns {Object} Copia de obj sin las claves que pasaron el filtro
 */
function discard (props, obj) {
  const aux = { ...obj } // cloneDeep(obj)
  props.forEach(prop => setNestedValue(prop, aux, undefined))
  return aux
//   return props.reduce((acc, prop) => (({ [prop]: _, ...rest }) => rest)(acc), obj)
}

/** Devuelve un objeto con las claves que pasen el filtro
 * @param {Object} obj Objeto a copiar
 * @param {KeyPredicate} predicate Filtro que indicará si una clave se deberá descartar en la copia de obj. El método filter llama a la función predicate una vez por cada clave en obj.
 * @param {*} [thisArg] Un objeto al que puede hacer referencia la palabra clave this en la función predicado. Si se omite thisArg, se utiliza undefined como valor de this.
 * @returns {Object} Copia de obj sin las claves que pasaron el filtro
 */
function discardByPredicate (obj, predicate, thisArg) {
  const props = Object.keys(obj).filter(predicate, thisArg)
  return discard(props, obj)
}

export { preserve, discard, preserveByPredicate, discardByPredicate }
